export default {
    requestPermission: async () => {},
    createChannel: async () => {},
    displayNotification: async () => {},
};
